var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('router-link',{attrs:{"to":"/login-register"}},[_vm._v(" Welcome to our Ticketing Portal. Create an Account here. ")]),_c('upper-navbar',{attrs:{"account-links":_vm.accountLinks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }